var React = require('react');

function SharemailInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#fff","key":0}),React.createElement("path",{"d":"M10.76,10.76H21.24a1.31,1.31,0,0,1,1.31,1.31v7.86a1.31,1.31,0,0,1-1.31,1.31H10.76a1.31,1.31,0,0,1-1.31-1.31V12.07A1.31,1.31,0,0,1,10.76,10.76Z","fill":"none","stroke":"#003c61","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M22.55,12.07,16,16.66,9.45,12.07","fill":"none","stroke":"#003c61","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":2})]);
}

SharemailInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = SharemailInline;

SharemailInline.default = SharemailInline;
